export function findNearestElementMatchingAttribute(
  el,
  attributeName,
  attributeValue
) {
  if (!el || !el.getAttribute || !attributeName || !attributeValue) {
    return null;
  }

  if (el.getAttribute(attributeName) === attributeValue) {
    return el;
  } else if (el.parentNode) {
    return findNearestElementMatchingAttribute(
      el.parentNode,
      attributeName,
      attributeValue
    );
  }
  return null;
}

// https://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes
export function forceRedraw(el) {
  if (el) {
    const current = el.style.display;
    el.style.display = 'none';
    // eslint-disable-next-line no-unused-vars
    const h = el.offsetHeight;
    el.style.display = current;
  }
}

// Used to check if an element is the parent of another element
export function contains(outer, inner) {
  return outer && inner instanceof Node && outer.contains(inner);
}

export function findNearestScrollParent(node) {
  function isScrollable(el) {
    return getComputedStyle(el)['overflow-y'] === 'auto';
  }

  if (isScrollable(node)) {
    return node;
  } else if (node.parentElement) {
    return findNearestScrollParent(node.parentElement);
  }
  return null;
}

// https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/

export function getFocusableElements(node) {
  return node.querySelectorAll(
    'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
}
